import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import { lightSkeletonTheme } from "./skeletonTheme";

// The fake nav bar shown for the brief window while App.jsx is fetching the
// API token and initializing Stripe - before the router (and the real
// MainNavigation) has mounted at all. Exported separately so
// NavBarSkeleton + a specific page skeleton can be paired up (see App.jsx)
// instead of always falling back to the generic body below.
export const NavBarSkeleton = () => (
  <SkeletonTheme {...lightSkeletonTheme}>
    <div className="bg-white shadow-[0_2px_8px_rgba(0,0,0,0.08)] py-[6px]">
      <div className="container flex items-center justify-between mx-auto py-3 px-4">
        <Skeleton width={140} height={32} />
        <div className="hidden sm:flex gap-6">
          <Skeleton width={60} height={16} />
          <Skeleton width={60} height={16} />
          <Skeleton width={60} height={16} />
          <Skeleton width={60} height={16} />
        </div>
        <Skeleton circle width={28} height={28} />
      </div>
    </div>
  </SkeletonTheme>
);

// Fallback body for routes that don't have their own tailored skeleton yet
// (Contact, Checkout, Confirmation, Privacy Policy).
const GenericBodySkeleton = () => (
  <SkeletonTheme {...lightSkeletonTheme}>
    <div className="outer-container container px-6 py-14">
      <Skeleton height={48} width="60%" containerClassName="block mx-auto mb-4" />
      <Skeleton height={20} width="40%" containerClassName="block mx-auto mb-10" />
      <div className="grid grid-cols-2 md:grid-cols-4 gap-5">
        <Skeleton className="aspect-square" />
        <Skeleton className="aspect-square" />
        <Skeleton className="aspect-square" />
        <Skeleton className="aspect-square" />
      </div>
    </div>
  </SkeletonTheme>
);

const AppSkeleton = () => (
  <div className="min-h-screen">
    <NavBarSkeleton />
    <GenericBodySkeleton />
  </div>
);

export default AppSkeleton;
